import React from 'react';
import {
  CloseWrapper,
  Container,
  IconClose,
  ImgUpload,
  Relative,
} from './styled';

interface ImageItemProps {
  image?: string;
  onDelete?: () => any;
  onClick: () => any;
  dimensions?: any;
}

function ImageItem({ image: imageSrc, onDelete, dimensions, onClick }: ImageItemProps) {
  if (!imageSrc) {
    return <div />;
  }

  const haveWings = dimensions?.height > dimensions?.width;

  return (
    <Relative draggable="false">
      <CloseWrapper onClick={onDelete} draggable="false">
        <IconClose className="icon-compose_close" />
      </CloseWrapper>
      <Container onClick={onClick} haveWings={haveWings} draggable="false">
        <ImgUpload draggable="false" alt="uploader" src={imageSrc} />
      </Container>
    </Relative>
  );
}

export default React.memo(ImageItem);
